import { Button, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
	disabled?: boolean;
};

export const AddRowButton: FC<Props> = ({ label, onClick, disabled }) => {
	const theme = useTheme();

	return (
		<Button
			variant="addRow"
			disableRipple
			disabled={disabled}
			onClick={onClick}
		>
			<Plus size={theme.iconSize.sm} />
			{label}
		</Button>
	);
};
